var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKsOnboardingStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 270,
    viewBox: "0 0 562 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_933_49636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 562,
    height: 270
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 270,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_933_49636)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 205.739,
    height: 86.515,
    rx: 9.28571,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.857143,
    y: 46.0178,
    width: 560.286,
    height: 238.541,
    rx: 21.0173,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.71429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 46.1606,
    width: 560,
    height: 238.255,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6893,
    y: 143.182,
    width: 12.9,
    height: 11.6957,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6893,
    y: 174.795,
    width: 12.9,
    height: 11.6957,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6893,
    y: 208.043,
    width: 12.9,
    height: 11.6957,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6893,
    y: 241.291,
    width: 12.9,
    height: 11.6957,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6893,
    y: 113.376,
    width: 12.9,
    height: 11.6957,
    stroke: "black",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6206 118.649L38.5375 121.004L43.2525 116.188",
    stroke: "black",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.063,
    y: 65.8981,
    width: 73.8857,
    height: 23.9629,
    rx: 4,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6642 76.6404C50.8517 76.6404 51.0392 76.8279 51.0392 77.0154V77.7654C51.0392 77.9763 50.8517 78.1404 50.6642 78.1404H47.2892V81.5154C47.2892 81.7263 47.1017 81.8904 46.9142 81.8904H46.1642C45.9533 81.8904 45.7892 81.7263 45.7892 81.5154V78.1404H42.4142C42.2033 78.1404 42.0392 77.9763 42.0392 77.7654V77.0154C42.0392 76.8279 42.2033 76.6404 42.4142 76.6404H45.7892V73.2654C45.7892 73.0779 45.9533 72.8904 46.1642 72.8904H46.9142C47.1017 72.8904 47.2892 73.0779 47.2892 73.2654V76.6404H50.6642Z",
    fill: "#22283C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0215,
    y: 76.8811,
    width: 37.9413,
    height: 1.99691,
    fill: "#22283C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9944 19.5063V17.887H77.6433V19.5063H73.7533V30.3545H71.8783V19.5063H67.9944ZM82.3034 30.5432C81.3822 30.5432 80.5887 30.3464 79.9231 29.9527C79.2616 29.555 78.7503 28.9969 78.3891 28.2786C78.0319 27.5562 77.8533 26.71 77.8533 25.74C77.8533 24.7823 78.0319 23.9381 78.3891 23.2076C78.7503 22.4771 79.2535 21.9068 79.8988 21.4969C80.5481 21.087 81.3071 20.8821 82.1756 20.8821C82.7032 20.8821 83.2145 20.9693 83.7097 21.1439C84.2048 21.3184 84.6492 21.5923 85.0429 21.9657C85.4365 22.3391 85.747 22.8241 85.9743 23.4206C86.2015 24.0132 86.3152 24.7336 86.3152 25.5818V26.2271H78.8822V24.8634H84.5315C84.5315 24.3845 84.4341 23.9604 84.2393 23.5911C84.0445 23.2177 83.7705 22.9235 83.4175 22.7084C83.0684 22.4933 82.6585 22.3857 82.1878 22.3857C81.6764 22.3857 81.23 22.5116 80.8485 22.7632C80.471 23.0107 80.1788 23.3354 79.9718 23.7372C79.7689 24.1349 79.6675 24.5672 79.6675 25.0339V26.0992C79.6675 26.7242 79.777 27.2559 79.9962 27.6942C80.2194 28.1325 80.5299 28.4673 80.9276 28.6986C81.3253 28.9259 81.79 29.0396 82.3217 29.0396C82.6666 29.0396 82.9812 28.9909 83.2653 28.8935C83.5494 28.792 83.7949 28.6418 84.0019 28.443C84.2089 28.2441 84.3671 27.9986 84.4767 27.7064L86.1995 28.0168C86.0615 28.5241 85.814 28.9685 85.4568 29.35C85.1037 29.7275 84.6593 30.0217 84.1236 30.2327C83.592 30.4397 82.9852 30.5432 82.3034 30.5432ZM95.3417 23.2867L93.6919 23.5789C93.6229 23.3679 93.5133 23.167 93.3632 22.9762C93.2171 22.7855 93.0182 22.6293 92.7666 22.5075C92.515 22.3857 92.2004 22.3249 91.823 22.3249C91.3076 22.3249 90.8774 22.4405 90.5324 22.6719C90.1874 22.8991 90.015 23.1934 90.015 23.5546C90.015 23.8671 90.1306 24.1187 90.362 24.3094C90.5933 24.5002 90.9667 24.6564 91.4821 24.7782L92.9675 25.1191C93.8279 25.318 94.4691 25.6244 94.8912 26.0383C95.3133 26.4523 95.5243 26.99 95.5243 27.6516C95.5243 28.2116 95.362 28.7108 95.0373 29.1491C94.7167 29.5834 94.2682 29.9243 93.6919 30.1719C93.1197 30.4194 92.4561 30.5432 91.7012 30.5432C90.6542 30.5432 89.7999 30.32 89.1383 29.8736C88.4768 29.4231 88.071 28.7839 87.9208 27.956L89.6801 27.6881C89.7897 28.1467 90.015 28.4937 90.3559 28.7291C90.6968 28.9604 91.1412 29.0761 91.6891 29.0761C92.2857 29.0761 92.7625 28.9523 93.1197 28.7047C93.4768 28.4531 93.6554 28.1467 93.6554 27.7855C93.6554 27.4933 93.5458 27.2478 93.3266 27.0489C93.1116 26.85 92.7808 26.6999 92.3344 26.5984L90.7516 26.2514C89.879 26.0525 89.2337 25.736 88.8157 25.3017C88.4017 24.8675 88.1948 24.3176 88.1948 23.652C88.1948 23.1 88.349 22.6171 88.6574 22.2031C88.9659 21.7892 89.392 21.4665 89.9358 21.2352C90.4797 20.9998 91.1026 20.8821 91.8047 20.8821C92.8153 20.8821 93.6107 21.1012 94.1911 21.5396C94.7715 21.9738 95.155 22.5562 95.3417 23.2867ZM101.89 21.0038V22.4649H96.7829V21.0038H101.89ZM98.1526 18.7636H99.9728V27.609C99.9728 27.962 100.026 28.2279 100.131 28.4064C100.237 28.581 100.373 28.7007 100.539 28.7656C100.709 28.8265 100.894 28.8569 101.093 28.8569C101.239 28.8569 101.367 28.8468 101.477 28.8265C101.586 28.8062 101.671 28.79 101.732 28.7778L102.061 30.2814C101.955 30.322 101.805 30.3626 101.61 30.4032C101.416 30.4478 101.172 30.4722 100.88 30.4762C100.401 30.4844 99.9546 30.3991 99.5406 30.2206C99.1267 30.042 98.7918 29.766 98.5362 29.3926C98.2805 29.0193 98.1526 28.5505 98.1526 27.9864V18.7636ZM115.448 23.2867L113.798 23.5789C113.729 23.3679 113.619 23.167 113.469 22.9762C113.323 22.7855 113.124 22.6293 112.873 22.5075C112.621 22.3857 112.306 22.3249 111.929 22.3249C111.414 22.3249 110.983 22.4405 110.638 22.6719C110.293 22.8991 110.121 23.1934 110.121 23.5546C110.121 23.8671 110.237 24.1187 110.468 24.3094C110.699 24.5002 111.073 24.6564 111.588 24.7782L113.073 25.1191C113.934 25.318 114.575 25.6244 114.997 26.0383C115.419 26.4523 115.63 26.99 115.63 27.6516C115.63 28.2116 115.468 28.7108 115.143 29.1491C114.823 29.5834 114.374 29.9243 113.798 30.1719C113.226 30.4194 112.562 30.5432 111.807 30.5432C110.76 30.5432 109.906 30.32 109.244 29.8736C108.583 29.4231 108.177 28.7839 108.027 27.956L109.786 27.6881C109.896 28.1467 110.121 28.4937 110.462 28.7291C110.803 28.9604 111.247 29.0761 111.795 29.0761C112.392 29.0761 112.869 28.9523 113.226 28.7047C113.583 28.4531 113.761 28.1467 113.761 27.7855C113.761 27.4933 113.652 27.2478 113.433 27.0489C113.218 26.85 112.887 26.6999 112.44 26.5984L110.858 26.2514C109.985 26.0525 109.34 25.736 108.922 25.3017C108.508 24.8675 108.301 24.3176 108.301 23.652C108.301 23.1 108.455 22.6171 108.763 22.2031C109.072 21.7892 109.498 21.4665 110.042 21.2352C110.586 20.9998 111.209 20.8821 111.911 20.8821C112.921 20.8821 113.717 21.1012 114.297 21.5396C114.877 21.9738 115.261 22.5562 115.448 23.2867ZM123.555 26.4767V21.0038H125.381V30.3545H123.591V28.7352H123.494C123.279 29.2344 122.934 29.6504 122.459 29.9831C121.988 30.3119 121.402 30.4762 120.7 30.4762C120.099 30.4762 119.568 30.3443 119.105 30.0805C118.646 29.8127 118.285 29.417 118.021 28.8935C117.762 28.3699 117.632 27.7226 117.632 26.9515V21.0038H119.452V26.7323C119.452 27.3695 119.628 27.8768 119.981 28.2542C120.335 28.6317 120.793 28.8204 121.357 28.8204C121.698 28.8204 122.037 28.7352 122.374 28.5647C122.715 28.3943 122.997 28.1366 123.22 27.7916C123.447 27.4466 123.559 27.0083 123.555 26.4767ZM127.827 30.3545V21.0038H129.647V30.3545H127.827ZM128.746 19.5611C128.43 19.5611 128.158 19.4556 127.93 19.2445C127.707 19.0294 127.596 18.7737 127.596 18.4775C127.596 18.1771 127.707 17.9215 127.93 17.7104C128.158 17.4953 128.43 17.3878 128.746 17.3878C129.063 17.3878 129.333 17.4953 129.556 17.7104C129.783 17.9215 129.897 18.1771 129.897 18.4775C129.897 18.7737 129.783 19.0294 129.556 19.2445C129.333 19.4556 129.063 19.5611 128.746 19.5611ZM136.461 21.0038V22.4649H131.353V21.0038H136.461ZM132.723 18.7636H134.543V27.609C134.543 27.962 134.596 28.2279 134.701 28.4064C134.807 28.581 134.943 28.7007 135.109 28.7656C135.28 28.8265 135.464 28.8569 135.663 28.8569C135.809 28.8569 135.937 28.8468 136.047 28.8265C136.156 28.8062 136.242 28.79 136.302 28.7778L136.631 30.2814C136.526 30.322 136.376 30.3626 136.181 30.4032C135.986 30.4478 135.742 30.4722 135.45 30.4762C134.971 30.4844 134.525 30.3991 134.111 30.2206C133.697 30.042 133.362 29.766 133.106 29.3926C132.851 29.0193 132.723 28.5505 132.723 27.9864V18.7636ZM142.404 30.5432C141.483 30.5432 140.689 30.3464 140.024 29.9527C139.362 29.555 138.851 28.9969 138.489 28.2786C138.132 27.5562 137.954 26.71 137.954 25.74C137.954 24.7823 138.132 23.9381 138.489 23.2076C138.851 22.4771 139.354 21.9068 139.999 21.4969C140.649 21.087 141.407 20.8821 142.276 20.8821C142.804 20.8821 143.315 20.9693 143.81 21.1439C144.305 21.3184 144.75 21.5923 145.143 21.9657C145.537 22.3391 145.847 22.8241 146.075 23.4206C146.302 24.0132 146.416 24.7336 146.416 25.5818V26.2271H138.983V24.8634H144.632C144.632 24.3845 144.535 23.9604 144.34 23.5911C144.145 23.2177 143.871 22.9235 143.518 22.7084C143.169 22.4933 142.759 22.3857 142.288 22.3857C141.777 22.3857 141.33 22.5116 140.949 22.7632C140.571 23.0107 140.279 23.3354 140.072 23.7372C139.869 24.1349 139.768 24.5672 139.768 25.0339V26.0992C139.768 26.7242 139.877 27.2559 140.097 27.6942C140.32 28.1325 140.63 28.4673 141.028 28.6986C141.426 28.9259 141.89 29.0396 142.422 29.0396C142.767 29.0396 143.082 28.9909 143.366 28.8935C143.65 28.792 143.895 28.6418 144.102 28.443C144.309 28.2441 144.468 27.9986 144.577 27.7064L146.3 28.0168C146.162 28.5241 145.914 28.9685 145.557 29.35C145.204 29.7275 144.76 30.0217 144.224 30.2327C143.692 30.4397 143.086 30.5432 142.404 30.5432Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6248,
    y: 13.1451,
    width: 20.075,
    height: 17.9675,
    fill: "#76BF42",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7541,
    y: 16.9015,
    width: 19.7879,
    height: 17.6804,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6475 20.3252H47.6892",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6475 25.7517H47.6892",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3154 31.026H47.52",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5502,
    y: 19.3961,
    width: 2.15357,
    height: 1.8525,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5502,
    y: 24.8153,
    width: 2.15357,
    height: 1.8525,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5502,
    y: 30.2347,
    width: 2.15357,
    height: 1.8525,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9159,
    y: 113.33,
    width: 10.9449,
    height: 9.76466,
    fill: "#76BF42",
    stroke: "#121822",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 115.353,
    width: 10.9449,
    height: 9.76466,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 117.202H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 120.241H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.834 123.195H76.4285",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 116.443,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 119.478,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 122.511,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.893,
    y: 116.515,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3179,
    y: 116.344,
    width: 93.3322,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 116.515,
    width: 58.2071,
    height: 5.41929,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9173,
    y: 144.041,
    width: 10.942,
    height: 9.7618,
    fill: "#76BF42",
    stroke: "#22283C",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 146.063,
    width: 10.9449,
    height: 9.76466,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 147.912H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 150.951H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.834 153.904H76.4285",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 147.151,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 150.187,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 153.221,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.893,
    y: 147.224,
    width: 49.175,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3179,
    y: 147.053,
    width: 72.2571,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 147.224,
    width: 58.2071,
    height: 5.41929,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9173,
    y: 174.75,
    width: 10.942,
    height: 9.7618,
    fill: "#76BF42",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 176.772,
    width: 10.9449,
    height: 9.76466,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 178.621H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 181.66H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.834 184.614H76.4285",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 177.861,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 180.896,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 183.93,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.893,
    y: 177.933,
    width: 39.1393,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3179,
    y: 177.762,
    width: 108.386,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 177.933,
    width: 58.2071,
    height: 5.41929,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9873,
    y: 208.068,
    width: 10.802,
    height: 9.6218,
    fill: "#76BF42",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 210.02,
    width: 10.9449,
    height: 9.76466,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 211.869H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 214.908H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.834 217.862H76.4285",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 211.109,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 214.144,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 217.178,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.893,
    y: 211.181,
    width: 39.1393,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3179,
    y: 211.181,
    width: 84.3,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 211.181,
    width: 58.2071,
    height: 5.41929,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9873,
    y: 241.317,
    width: 10.802,
    height: 9.6218,
    fill: "#76BF42",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 243.268,
    width: 10.9449,
    height: 9.76466,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 245.117H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4595 248.156H76.5228",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.834 251.109H76.4285",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 244.357,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 247.392,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9248,
    y: 250.426,
    width: 1.686,
    height: 1.5174,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.893,
    y: 244.429,
    width: 39.1393,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3179,
    y: 244.6,
    width: 71.2536,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 244.429,
    width: 58.2071,
    height: 5.41929,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 116.515,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.807,
    y: 116.344,
    width: 19.0679,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 147.224,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.807,
    y: 147.053,
    width: 19.0679,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 177.933,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.807,
    y: 177.762,
    width: 19.0679,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 211.181,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.807,
    y: 211.181,
    width: 19.0679,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.493,
    y: 244.429,
    width: 58.2071,
    height: 5.41929,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.807,
    y: 244.6,
    width: 19.0679,
    height: 5.41929,
    fill: "#ECEEF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsOnboardingStep3);
export default __webpack_public_path__ + "static/media/ks_onboarding_step3.d0bfe62f906b2937b980e4e6cb17c755.svg";
export { ForwardRef as ReactComponent };